import React, { useState } from 'react';
import { RefreshCw, Search, AlertTriangle, ArrowRight } from 'lucide-react';
import { Card, Button, ProgressBar, StatusPill } from '../components/ui/Primitives';
const DEPARTMENTS = ['IT', 'LO', 'Managing Partner', 'Recruiter', 'TL/DL', 'VA LO'];
const OWNERS = [{
  name: 'Martin Palaj',
  dept: 'VA LO',
  prospects: 607,
  total: 61880,
  loaded: 467,
  page: 5,
  totalPages: 619
}, {
  name: 'Carla Nguyen',
  dept: 'VA LO',
  prospects: 412,
  total: 38420,
  loaded: 412,
  page: 1,
  totalPages: 96
}, {
  name: 'Devon Pierce',
  dept: 'VA LO',
  prospects: 588,
  total: 47210,
  loaded: 588,
  page: 1,
  totalPages: 80
}, {
  name: 'Sarah Jenkins',
  dept: 'LO',
  prospects: 1247,
  total: 42130,
  loaded: 1247,
  page: 1,
  totalPages: 34
}, {
  name: 'Mike Chen',
  dept: 'LO',
  prospects: 982,
  total: 28401,
  loaded: 982,
  page: 1,
  totalPages: 29
}, {
  name: 'Renee Carter',
  dept: 'LO',
  prospects: 715,
  total: 19880,
  loaded: 715,
  page: 1,
  totalPages: 28
}, {
  name: 'David Smith',
  dept: 'TL/DL',
  prospects: 314,
  total: 12450,
  loaded: 314,
  page: 1,
  totalPages: 40
}, {
  name: 'Yuki Tanaka',
  dept: 'TL/DL',
  prospects: 268,
  total: 9870,
  loaded: 268,
  page: 1,
  totalPages: 37
}, {
  name: 'Emily Davis',
  dept: 'Recruiter',
  prospects: 188,
  total: 5210,
  loaded: 188,
  page: 1,
  totalPages: 28
}, {
  name: 'Jordan Blake',
  dept: 'Recruiter',
  prospects: 142,
  total: 4180,
  loaded: 142,
  page: 1,
  totalPages: 30
}, {
  name: 'Priya Shah',
  dept: 'Managing Partner',
  prospects: 76,
  total: 1820,
  loaded: 76,
  page: 1,
  totalPages: 24
}, {
  name: 'Marcus Hill',
  dept: 'Managing Partner',
  prospects: 58,
  total: 1340,
  loaded: 58,
  page: 1,
  totalPages: 23
}, {
  name: 'Alex Rivera',
  dept: 'IT',
  prospects: 22,
  total: 22,
  loaded: 22,
  page: 1,
  totalPages: 1
}, {
  name: 'Sam Okafor',
  dept: 'IT',
  prospects: 18,
  total: 18,
  loaded: 18,
  page: 1,
  totalPages: 1
}];
const BONZO_PROSPECTS = [{
  id: 'bz_89213',
  name: 'James Smith',
  phone: '+1 (555) 234-5678',
  stage: 'New Lead'
}, {
  id: 'bz_89214',
  name: 'Mary Johnson',
  phone: '+1 (555) 312-9981',
  stage: 'Application'
}, {
  id: 'bz_89215',
  name: 'Robert Williams',
  phone: '+1 (555) 422-7710',
  stage: 'Connected'
}, {
  id: 'bz_89216',
  name: 'Patricia Brown',
  phone: '+1 (555) 538-2204',
  stage: 'Attempted Contact'
}, {
  id: 'bz_89217',
  name: 'John Garcia',
  phone: '+1 (555) 671-4423',
  stage: 'New Lead'
}, {
  id: 'bz_89218',
  name: 'Jennifer Davis',
  phone: '+1 (555) 802-1198',
  stage: 'Closed'
}, {
  id: 'bz_89219',
  name: 'Michael Miller',
  phone: '+1 (555) 914-3367',
  stage: 'Application'
}, {
  id: 'bz_89220',
  name: 'Linda Rodriguez',
  phone: '+1 (555) 145-9023',
  stage: 'Connected'
}];
const KONNECTD_CONTACTS = [{
  id: 'k_44102',
  name: 'William Martinez',
  phone: '+1 (555) 287-4419',
  email: 'wmartinez@example.com'
}, {
  id: 'k_44103',
  name: 'Elizabeth Hernandez',
  phone: '+1 (555) 391-8867',
  email: 'eh@example.com'
}, {
  id: 'k_44104',
  name: 'Charles Lopez',
  phone: '+1 (555) 472-3320',
  email: 'clopez@example.com'
}, {
  id: 'k_44105',
  name: 'Barbara Gonzalez',
  phone: '+1 (555) 588-1102',
  email: 'bgonz@example.com'
}, {
  id: 'k_44106',
  name: 'Joseph Wilson',
  phone: '+1 (555) 619-7745',
  email: 'jwilson@example.com'
}];
export function Reassignment() {
  const [activeDepts, setActiveDepts] = useState<string[]>(['LO']);
  const [selectedOwner, setSelectedOwner] = useState<string>('Martin Palaj');
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(true); // start with prospects already loaded (matches screenshot's "loaded" state)
  const [selectedBonzo, setSelectedBonzo] = useState<Set<string>>(new Set());
  const [selectedKonnectd, setSelectedKonnectd] = useState<Set<string>>(new Set());
  const [bonzoLoading, setBonzoLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isRunning, setIsRunning] = useState(false);
  const [progress, setProgress] = useState(0);
  const [refreshSpin, setRefreshSpin] = useState(false);
  const [logEntries, setLogEntries] = useState<{
    from: string;
    to: string;
    count: number;
    time: string;
  }[]>([]);
  const filteredOwners = activeDepts.length === 0 ? OWNERS : OWNERS.filter(o => activeDepts.includes(o.dept));
  const currentOwner = OWNERS.find(o => o.name === selectedOwner);
  // Determine round-robin pool: same department, excluding the source owner
  const roundRobinPool = currentOwner ? OWNERS.filter(o => o.dept === currentOwner.dept && o.name !== currentOwner.name) : [];
  const toggleDept = (d: string) => {
    setActiveDepts(prev => prev.includes(d) ? prev.filter(x => x !== d) : [...prev, d]);
    // reset selected owner if it no longer matches the new filter
    const next = activeDepts.includes(d) ? activeDepts.filter(x => x !== d) : [...activeDepts, d];
    if (next.length > 0 && currentOwner && !next.includes(currentOwner.dept)) {
      const firstMatch = OWNERS.find(o => next.includes(o.dept));
      if (firstMatch) setSelectedOwner(firstMatch.name);
    }
  };
  const handleFindProspects = () => {
    setBonzoLoading(true);
    setLoaded(false);
    setSelectedBonzo(new Set());
    setSelectedKonnectd(new Set());
    setTimeout(() => {
      setBonzoLoading(false);
      setLoaded(true);
    }, 1400);
  };
  const handleRefreshTeam = () => {
    setRefreshSpin(true);
    setTimeout(() => setRefreshSpin(false), 1000);
  };
  const toggleAllBonzo = () => {
    if (selectedBonzo.size === BONZO_PROSPECTS.length) {
      setSelectedBonzo(new Set());
    } else {
      setSelectedBonzo(new Set(BONZO_PROSPECTS.map(p => p.id)));
    }
  };
  const toggleBonzo = (id: string) => {
    setSelectedBonzo(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);else next.add(id);
      return next;
    });
  };
  const toggleAllKonnectd = () => {
    if (selectedKonnectd.size === KONNECTD_CONTACTS.length) {
      setSelectedKonnectd(new Set());
    } else {
      setSelectedKonnectd(new Set(KONNECTD_CONTACTS.map(c => c.id)));
    }
  };
  const toggleKonnectd = (id: string) => {
    setSelectedKonnectd(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);else next.add(id);
      return next;
    });
  };
  const totalSelected = selectedBonzo.size + selectedKonnectd.size;
  const handleRun = () => {
    setShowConfirmModal(false);
    setIsRunning(true);
    setProgress(0);
    const interval = setInterval(() => {
      setProgress(p => {
        if (p >= 100) {
          clearInterval(interval);
          // log the job
          setLogEntries(prev => [{
            from: selectedOwner,
            to: `Round Robin · ${currentOwner?.dept ?? ''} (${roundRobinPool.length} reps)`,
            count: totalSelected,
            time: new Date().toLocaleTimeString()
          }, ...prev]);
          setTimeout(() => {
            setIsRunning(false);
            setSelectedBonzo(new Set());
            setSelectedKonnectd(new Set());
          }, 800);
          return 100;
        }
        return p + 8;
      });
    }, 200);
  };
  return <div className="max-w-7xl mx-auto space-y-6 relative pb-24" data-id="element-673">
      {showConfirmModal && <div className="fixed inset-0 z-50 flex items-center justify-center" data-id="element-674">
          <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={() => setShowConfirmModal(false)} data-id="element-675" />
          <Card className="w-[440px] p-6 relative z-10 shadow-2xl animate-in zoom-in-95" data-id="element-676">
            <div className="flex items-center gap-3 text-amber-600 mb-4" data-id="element-677">
              <AlertTriangle className="w-6 h-6" data-id="element-678" />
              <h3 className="text-lg font-semibold text-slate-900" data-id="element-679">
                Confirm Reassignment
              </h3>
            </div>
            <p className="text-sm text-slate-600 mb-4" data-id="element-680">
              Distribute <strong data-id="element-681">{totalSelected}</strong> records (
              {selectedBonzo.size} Bonzo, {selectedKonnectd.size} Konnectd) from{' '}
              <strong data-id="element-682">{selectedOwner}</strong> via round robin across the{' '}
              <strong data-id="element-683">{currentOwner?.dept}</strong> department.
            </p>
            {roundRobinPool.length > 0 ? <div className="mb-6 p-3 bg-slate-50 border border-slate-200 rounded-lg" data-id="element-684">
                <div className="text-[10px] font-semibold uppercase tracking-wider text-slate-500 mb-2" data-id="element-685">
                  Round-robin pool ({roundRobinPool.length} reps)
                </div>
                <div className="flex flex-wrap gap-1.5" data-id="element-686">
                  {roundRobinPool.map(r => <span key={r.name} className="px-2 py-0.5 bg-white border border-slate-200 rounded-md text-xs text-slate-700" data-id="element-687">
                      {r.name}
                    </span>)}
                </div>
              </div> : <div className="mb-6 p-3 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-800" data-id="element-688">
                No other team members in the{' '}
                <strong data-id="element-689">{currentOwner?.dept}</strong> department. Add reps
                before running.
              </div>}
            <div className="flex justify-end gap-3" data-id="element-690">
              <Button variant="outline" onClick={() => setShowConfirmModal(false)} data-id="element-691">
                Cancel
              </Button>
              <Button variant="primary" onClick={handleRun} disabled={roundRobinPool.length === 0} data-id="element-692">
                Confirm & Run
              </Button>
            </div>
          </Card>
        </div>}

      {/* Header */}
      <div className="flex items-start justify-between" data-id="element-693">
        <div data-id="element-694">
          <h1 className="text-xl font-semibold text-slate-900" data-id="element-695">
            Prospect Reassignment
          </h1>
          <p className="text-sm text-slate-500" data-id="element-696">
            Find prospects by owner and reassign them to other team members.
          </p>
        </div>
        <Button variant="outline" size="sm" onClick={handleRefreshTeam} data-id="element-697">
          <RefreshCw className={`w-4 h-4 mr-2 ${refreshSpin ? 'animate-spin' : ''}`} data-id="element-698" />
          Refresh Team List
        </Button>
      </div>

      {/* Step 1: Department filter */}
      <div className="space-y-2" data-id="element-699">
        <div className="flex items-baseline gap-2" data-id="element-700">
          <span className="text-sm font-semibold text-slate-800" data-id="element-701">
            Filter by department
          </span>
          <span className="text-xs text-slate-500" data-id="element-702">
            (select to show only those)
          </span>
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-703">
          {DEPARTMENTS.map(d => {
          const isActive = activeDepts.includes(d);
          return <button key={d} onClick={() => toggleDept(d)} className={`px-3 py-1 text-xs font-medium rounded-full border transition-colors ${isActive ? 'bg-electric-500 text-white border-electric-500 shadow-sm' : 'bg-white text-slate-600 border-slate-300 hover:border-slate-400 hover:bg-slate-50'}`} data-id="element-704">
                {d}
              </button>;
        })}
          {activeDepts.length > 0 && <button onClick={() => setActiveDepts([])} className="px-3 py-1 text-xs font-medium text-slate-500 hover:text-slate-700" data-id="element-705">
              Clear
            </button>}
        </div>
      </div>

      {/* Step 2: Select Source Owner */}
      <div className="space-y-3" data-id="element-706">
        <div className="text-sm font-semibold text-slate-800" data-id="element-707">
          1. Select Source Owner
        </div>
        <div className="flex items-center gap-3 flex-wrap" data-id="element-708">
          <select value={selectedOwner} onChange={e => setSelectedOwner(e.target.value)} className="h-10 min-w-[320px] rounded-lg border border-slate-300 bg-white px-3 text-sm font-medium text-slate-800 focus:ring-2 focus:ring-electric-500 focus:border-electric-500 shadow-sm" data-id="element-709">
            {filteredOwners.map(o => <option key={o.name} value={o.name} data-id="element-710">
                {o.name} [{o.dept}] — {o.prospects.toLocaleString()} prospects
              </option>)}
          </select>
          <Button variant="primary" onClick={handleFindProspects} disabled={bonzoLoading} data-id="element-711">
            <Search className="w-4 h-4 mr-2" data-id="element-712" />
            {bonzoLoading ? 'Loading…' : 'Find Prospects'}
          </Button>
          {currentOwner && <span className="text-xs text-slate-500 font-mono" data-id="element-713">
              {currentOwner.name}: {currentOwner.total.toLocaleString()} total —
              loaded {currentOwner.loaded} (page {currentOwner.page}/
              {currentOwner.totalPages})
            </span>}
        </div>
      </div>

      {/* Reassignment Log */}
      <Card className="p-4" data-id="element-714">
        <div className="text-sm font-semibold text-slate-800 mb-2" data-id="element-715">
          Reassignment Log
        </div>
        {logEntries.length === 0 ? <div className="text-xs text-slate-500" data-id="element-716">
            No jobs yet this session.
          </div> : <div className="space-y-2" data-id="element-717">
            {logEntries.map((e, i) => <div key={i} className="flex items-center gap-3 text-xs text-slate-600 bg-slate-50 px-3 py-2 rounded-lg border border-slate-100" data-id="element-718">
                <StatusPill status="success" data-id="element-719" />
                <span className="font-mono" data-id="element-720">{e.time}</span>
                <span className="font-medium text-slate-800" data-id="element-721">{e.from}</span>
                <ArrowRight className="w-3 h-3 text-slate-400" data-id="element-722" />
                <span className="font-medium text-slate-800" data-id="element-723">{e.to}</span>
                <span className="ml-auto font-mono text-electric-600" data-id="element-724">
                  {e.count} records
                </span>
              </div>)}
          </div>}
      </Card>

      {/* Side-by-side Bonzo + Konnectd */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-725">
        {/* Bonzo */}
        <Card className="overflow-hidden flex flex-col" data-id="element-726">
          <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-slate-50" data-id="element-727">
            <div className="flex items-center gap-2" data-id="element-728">
              <div className="w-6 h-6 rounded-md bg-orange-500/15 border border-orange-500/30 flex items-center justify-center text-xs font-bold text-orange-600" data-id="element-729">
                B
              </div>
              <span className="text-sm font-semibold text-slate-800" data-id="element-730">
                Bonzo Prospects
              </span>
              {bonzoLoading && <span className="text-xs text-slate-500 ml-1" data-id="element-731">Loading…</span>}
              {loaded && !bonzoLoading && <span className="text-xs text-slate-500 ml-1" data-id="element-732">
                  {BONZO_PROSPECTS.length} loaded
                </span>}
            </div>
            <div className="flex items-center gap-2" data-id="element-733">
              {bonzoLoading && <button className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-red-500 text-white text-xs font-medium" data-id="element-734">
                  <span className="w-1.5 h-1.5 bg-white rounded-sm" data-id="element-735" /> Stop
                </button>}
              <label className="inline-flex items-center gap-1.5 text-xs text-slate-600 cursor-pointer" data-id="element-736">
                <input type="checkbox" className="rounded border-slate-300 text-electric-500 focus:ring-electric-500" checked={loaded && selectedBonzo.size === BONZO_PROSPECTS.length && BONZO_PROSPECTS.length > 0} onChange={toggleAllBonzo} disabled={!loaded || bonzoLoading} data-id="element-737" />
                All
              </label>
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-738">
            <table className="w-full text-left text-sm" data-id="element-739">
              <thead className="bg-white border-b border-slate-200" data-id="element-740">
                <tr data-id="element-741">
                  <th className="px-3 py-2 w-8" data-id="element-742"></th>
                  <th className="px-3 py-2 text-[10px] font-medium uppercase tracking-wider text-slate-500" data-id="element-743">
                    Name
                  </th>
                  <th className="px-3 py-2 text-[10px] font-medium uppercase tracking-wider text-slate-500" data-id="element-744">
                    ID
                  </th>
                  <th className="px-3 py-2 text-[10px] font-medium uppercase tracking-wider text-slate-500" data-id="element-745">
                    Phone
                  </th>
                  <th className="px-3 py-2 text-[10px] font-medium uppercase tracking-wider text-slate-500" data-id="element-746">
                    Stage
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-747">
                {bonzoLoading ? <tr data-id="element-748">
                    <td colSpan={5} className="px-3 py-10 text-center text-sm text-slate-400" data-id="element-749">
                      Loading…
                    </td>
                  </tr> : loaded ? BONZO_PROSPECTS.map(p => <tr key={p.id} className="hover:bg-slate-50 transition-colors" data-id="element-750">
                      <td className="px-3 py-2" data-id="element-751">
                        <input type="checkbox" className="rounded border-slate-300 text-electric-500 focus:ring-electric-500" checked={selectedBonzo.has(p.id)} onChange={() => toggleBonzo(p.id)} data-id="element-752" />
                      </td>
                      <td className="px-3 py-2 text-slate-800" data-id="element-753">{p.name}</td>
                      <td className="px-3 py-2 font-mono text-xs text-slate-500" data-id="element-754">
                        {p.id}
                      </td>
                      <td className="px-3 py-2 font-mono text-xs text-slate-600" data-id="element-755">
                        {p.phone}
                      </td>
                      <td className="px-3 py-2" data-id="element-756">
                        <span className="px-2 py-0.5 bg-slate-100 text-slate-700 text-[10px] rounded-md font-medium" data-id="element-757">
                          {p.stage}
                        </span>
                      </td>
                    </tr>) : <tr data-id="element-758">
                    <td colSpan={5} className="px-3 py-10 text-center text-sm text-slate-400" data-id="element-759">
                      Select an owner and click Find Prospects.
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Konnectd */}
        <Card className="overflow-hidden flex flex-col" data-id="element-760">
          <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-slate-50" data-id="element-761">
            <div className="flex items-center gap-2" data-id="element-762">
              <div className="w-6 h-6 rounded-md bg-teal-500/15 border border-teal-500/30 flex items-center justify-center text-xs font-bold text-teal-600" data-id="element-763">
                K
              </div>
              <span className="text-sm font-semibold text-slate-800" data-id="element-764">
                Konnectd Contacts
              </span>
              {loaded && <span className="text-xs text-slate-500 ml-1" data-id="element-765">
                  {KONNECTD_CONTACTS.length} linked
                </span>}
            </div>
            <label className="inline-flex items-center gap-1.5 text-xs text-slate-600 cursor-pointer" data-id="element-766">
              <input type="checkbox" className="rounded border-slate-300 text-electric-500 focus:ring-electric-500" checked={loaded && selectedKonnectd.size === KONNECTD_CONTACTS.length && KONNECTD_CONTACTS.length > 0} onChange={toggleAllKonnectd} disabled={!loaded} data-id="element-767" />
              All
            </label>
          </div>

          <div className="overflow-x-auto" data-id="element-768">
            <table className="w-full text-left text-sm" data-id="element-769">
              <thead className="bg-white border-b border-slate-200" data-id="element-770">
                <tr data-id="element-771">
                  <th className="px-3 py-2 w-8" data-id="element-772"></th>
                  <th className="px-3 py-2 text-[10px] font-medium uppercase tracking-wider text-slate-500" data-id="element-773">
                    Name
                  </th>
                  <th className="px-3 py-2 text-[10px] font-medium uppercase tracking-wider text-slate-500" data-id="element-774">
                    Phone
                  </th>
                  <th className="px-3 py-2 text-[10px] font-medium uppercase tracking-wider text-slate-500" data-id="element-775">
                    Email
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-776">
                {bonzoLoading ? <tr data-id="element-777">
                    <td colSpan={4} className="px-3 py-10 text-center text-sm text-slate-400" data-id="element-778">
                      Loading…
                    </td>
                  </tr> : loaded && KONNECTD_CONTACTS.length > 0 ? KONNECTD_CONTACTS.map(c => <tr key={c.id} className="hover:bg-slate-50 transition-colors" data-id="element-779">
                      <td className="px-3 py-2" data-id="element-780">
                        <input type="checkbox" className="rounded border-slate-300 text-electric-500 focus:ring-electric-500" checked={selectedKonnectd.has(c.id)} onChange={() => toggleKonnectd(c.id)} data-id="element-781" />
                      </td>
                      <td className="px-3 py-2 text-slate-800" data-id="element-782">{c.name}</td>
                      <td className="px-3 py-2 font-mono text-xs text-slate-600" data-id="element-783">
                        {c.phone}
                      </td>
                      <td className="px-3 py-2 text-xs text-slate-600" data-id="element-784">
                        {c.email}
                      </td>
                    </tr>) : <tr data-id="element-785">
                    <td colSpan={4} className="px-3 py-10 text-center text-sm text-slate-400" data-id="element-786">
                      No Konnectd user linked to this owner.
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* Sticky bottom action */}
      <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-30" data-id="element-787">
        <div className="bg-surface border border-slate-200 shadow-lg rounded-xl px-5 py-3 flex items-center gap-4 min-w-[640px]" data-id="element-788">
          {isRunning ? <div className="w-full flex items-center gap-4" data-id="element-789">
              <div className="flex-1" data-id="element-790">
                <div className="flex justify-between text-xs mb-1.5" data-id="element-791">
                  <span className="font-medium text-slate-700" data-id="element-792">
                    {progress === 100 ? 'Reassignment complete' : `Reassigning ${totalSelected} records…`}
                  </span>
                  <span className="font-mono text-electric-600" data-id="element-793">
                    {progress}%
                  </span>
                </div>
                <ProgressBar progress={progress} active={progress < 100} data-id="element-794" />
              </div>
            </div> : <>
              <div className="text-sm" data-id="element-795">
                <div className="font-semibold text-slate-900" data-id="element-796">
                  {totalSelected > 0 ? `${totalSelected} selected` : 'No records selected'}
                </div>
                <div className="text-xs text-slate-500" data-id="element-797">
                  {selectedBonzo.size} Bonzo · {selectedKonnectd.size} Konnectd
                  · From{' '}
                  <span className="font-medium text-slate-700" data-id="element-798">
                    {selectedOwner}
                  </span>{' '}
                  · Round Robin in{' '}
                  <span className="font-medium text-slate-700" data-id="element-799">
                    {currentOwner?.dept}
                  </span>{' '}
                  ({roundRobinPool.length} reps)
                </div>
              </div>
              <div className="ml-auto flex items-center gap-2" data-id="element-800">
                <Button variant="outline" size="sm" onClick={() => {
              setSelectedBonzo(new Set());
              setSelectedKonnectd(new Set());
            }} disabled={totalSelected === 0} data-id="element-801">
                  Clear
                </Button>
                <Button variant="primary" onClick={() => setShowConfirmModal(true)} disabled={totalSelected === 0 || roundRobinPool.length === 0} data-id="element-802">
                  Reassign {totalSelected > 0 ? `(${totalSelected})` : ''}
                </Button>
              </div>
            </>}
        </div>
      </div>
    </div>;
}